import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "Common/Hooks/UserHooks";

import { logoutUser } from "slices/thunk";

const AuthProtected = (props: any) => {
  const dispatch = useDispatch<any>();
  const { userProfile, loading, token } = useProfile();

  useEffect(() => {
    // Check authToken from localStorage
    const authToken = localStorage.getItem('authToken');
    const authUser = localStorage.getItem('authUser');

    // If no authToken or authUser, redirect to login
    if (!authToken || authToken === '' || authToken === 'null' || authToken === 'undefined') {
      dispatch(logoutUser());
      return;
    }

    if (!authUser || authUser === '' || authUser === 'null' || authUser === 'undefined') {
      dispatch(logoutUser());
      return;
    }

    // Set authorization if we have a valid token
    if (authToken) {
      setAuthorization(authToken);
    }
  }, [dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */
  
  // Check authToken from localStorage (primary check)
  const authToken = localStorage.getItem('authToken');
  const authUser = localStorage.getItem('authUser');

  // Debug logging
  console.log('AuthProtected - Checking authentication...');
  console.log('authToken:', authToken);
  console.log('authUser:', authUser);
  console.log('userProfile:', userProfile);
  console.log('loading:', loading);

  // If no authToken, redirect to login
  if (!authToken || authToken === '' || authToken === 'null' || authToken === 'undefined') {
    console.log('AuthProtected - No valid authToken, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // If no authUser, redirect to login
  if (!authUser || authUser === '' || authUser === 'null' || authUser === 'undefined') {
    console.log('AuthProtected - No valid authUser, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // If still loading, show loading (optional)
  if (loading) {
    console.log('AuthProtected - Still loading...');
    return <div>Loading...</div>; // or your loading component
  }

  console.log('AuthProtected - Authentication successful, rendering children');
  return <>{props.children}</>;
};


const AccessRoute = ({ component: Component, ...rest }: any) => {
  return (
    <Route
      {...rest}
      render={(props: any) => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };